import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Checkbox } from '../../../../../common/html/checkbox'
import { Element } from '../../../../../common/html/element'
import classes from '../index.module.scss'

const MAX_LENGTH = 3500

const NotePanel = ({ setting, setValue }) => {
  const plh = UseI18n('dynamicReport.PLH_NOTE')

  const { isHasNote = false, note = '' } = setting

  const onChangeCheckNote = (val) => {
    setValue('setting.isHasNote', val)
  }

  const onChangeNoteValue = (e) => {
    const value = e.target.value
    if (value.length <= MAX_LENGTH) {
      setValue('setting.note', value)
    }
  }

  return (
    <Element className={classes.notePanel} style={{ background: '#F3F3F3' }}>
      <div className="dFlex justifyContentBetween">
        <Checkbox
          title="dynamicReport.NOTE"
          isI18n
          style={{ paddingLeft: 6, fontWeight: 600 }}
          checked={isHasNote}
          onChange={onChangeCheckNote}
        />
        <Element className="fstItalic" style={{ color: '#9C9C9C' }}>
          <Translate value="dynamicReport.MAX_NOTE_PANEL" />
        </Element>
      </div>
      <Element
        elementName="textarea"
        style={{ border: '1px solid #E0E0E0', color: '#3A414B' }}
        className={classes.textarea}
        placeholder={plh}
        onChange={onChangeNoteValue}
        value={note}
      />
    </Element>
  )
}

NotePanel.propTypes = {
  setting: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default NotePanel
